import { AuthProvider, AuthOptions } from "./authProviderInterface";
import MicrosoftAuth from "./microsoftAuth";

export interface MsalAuthOptions extends AuthOptions {
    msalConfig: any;
    authProviderType?: string;
}

export class MsalAuthProvider implements AuthProvider {
    install(Vue: any, options: MsalAuthOptions): void {
        MicrosoftAuth.install(Vue, {
            serverUrl: options.serverUrl,
            msalConfig: options.msalConfig,
            authProviderType: options.authProviderType
        });
        this.setupInterceptors();
    }

    async getToken(): Promise<string | undefined> {
        return await MicrosoftAuth.getToken();
    }

    logout(): void {
        MicrosoftAuth.logout();
    }

    logoutRedirect(postLogoutRedirectUri?: string): void {
        void MicrosoftAuth.logoutRedirect(postLogoutRedirectUri).catch((err) =>
            console.error("MSAL redirect sign-out failed.", err));
    }

    setupInterceptors(): void {
        // Interceptors are set up in MicrosoftAuth.install
    }
}